/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import { useMemo } from 'react';

import { createStore, compose, applyMiddleware } from 'redux';
import { createTransform, persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './reducers';

let store: any;

const middlewares = [thunkMiddleware, promiseMiddleware];

// Only persist auth-related chat fields; reset transient login flow states on rehydrate
const chatPersistTransform = createTransform(
  (inbound) => inbound,
  (outbound: any) => ({
    loginSession: null,
    loginSessionState: '',
    loginSessionError: null,
    verification: null,
    verificationState: '',
    verificationError: null,
    chatwootToken: outbound?.chatwootToken ?? null,
    chatwootTokenState: outbound?.chatwootToken ? 'success' : '',
    chatwootTokenError: null,
    chatAuthToken: outbound?.chatAuthToken ?? '',
    isChatwootReady: outbound?.isChatwootReady ?? false,
  }),
  { whitelist: ['chat'] }
);

function initStore(initialState: any) {
  const persistConfig = {
    key: 'root',
    storage, // : localForage,
    whitelist: ['config', 'auth', 'chat'],
    transforms: [chatPersistTransform],
    // blacklist: ['navigation'],
  };
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  /**
   * ACTIVATE CODE BELOW TO LOG REDUX
   */
  // if (process.env.NODE_ENV === 'development') {
  //   // eslint-disable-next-line
  //   const { createLogger } = require('redux-logger')
  //   const logger = createLogger({
  //     // ...options
  //     predicate: (getState, action) => {
  //       console.info(
  //         '[Redux Log]',
  //         `Dispatch ::type >> ${action.type}`,
  //         action.payload ? '::payload >>' : '',
  //         action.payload ? action.payload : '',
  //       )
  //       // return action.type === SET_AUTH_VALIDATE_TOKEN // skip an action type
  //       return false
  //     },
  //   })

  //   middlewares.push(logger)
  // }
  // const composeEnhancers =
  //   (typeof window === 'object' &&
  //     (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })) ||
  //   compose;
  const composeEnhancers = compose;
  const _store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), compose)
  );
  const _persistor = persistStore(_store);

  return { store: _store, persistor: _persistor };
}

export const initializeStore = (preloadedState: any) => {
  const { store: _store, persistor } = initStore(preloadedState);
  let __store = store ?? _store;

  // After navigating to a page with an initial Redux state, merge that state
  // with the current state in the store, and create a new store
  if (preloadedState && store) {
    __store = initStore({
      ...store.getState(),
      ...preloadedState,
    });
    // Reset the current store
    store = undefined;
  }

  // For SSG and SSR always create a new store
  if (typeof window === 'undefined') return { store: __store, persistor };
  // Create the store once in the client
  if (!store) store = __store;

  return { store: __store, persistor };
};

export function useStore(initialState: any) {
  const __store = useMemo(() => initializeStore(initialState), [initialState]);
  return __store;
}
